import React from 'react';
import { IToast, ToastContext } from '../../contexts/toastContext';

export default function useToast(): { toasts: IToast[]; addToast: (toast: IToast) => void; removeToast: (id: number) => void } {
    return React.useContext(ToastContext);
}
